import { API, DISPLAY } from '../config'

export let apiUrl = () => `${API}/api/v2`
export const mygeotabUrl = 'https://my.geotab.com/apiv1'

export const originUrl = () => `${(API, DISPLAY)}`
